import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';

export default function SetPassword() {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirmPassword) {
      setError('Passwords must match.');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters long.');
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post('/auth/set-password', {
        token: searchParams.get('token'),
        password,
        confirmPassword,
      });
      setMessage(data?.message || 'Password set successfully. Please login.');
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          'This invite link is invalid or expired. Please ask your clinic admin to resend the invite.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4 py-10">
      <div className="w-full max-w-lg rounded-3xl bg-white p-8 shadow-xl">
        <div className="text-center">
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-indigo-500">Dektal 360 Pro</div>
          <h1 className="mt-3 text-3xl font-bold text-slate-900">Set Staff Password</h1>
          <p className="mt-2 text-sm text-slate-500">Create your password to access your clinic workspace.</p>
        </div>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="New password"
            className="w-full rounded-2xl border border-slate-300 px-4 py-3 outline-none focus:border-indigo-500"
            required
          />
          <input
            type="password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            placeholder="Confirm new password"
            className="w-full rounded-2xl border border-slate-300 px-4 py-3 outline-none focus:border-indigo-500"
            required
          />
          <button
            type="submit"
            disabled={loading || Boolean(message)}
            className="w-full rounded-2xl bg-indigo-600 px-4 py-3 font-semibold text-white disabled:opacity-60"
          >
            {loading ? 'Saving...' : 'Set Password'}
          </button>
        </form>

        {message ? <div className="mt-4 rounded-2xl bg-emerald-50 p-3 text-sm text-emerald-700">{message}</div> : null}
        {error ? <div className="mt-4 rounded-2xl bg-rose-50 p-3 text-sm text-rose-700">{error}</div> : null}

        <Link to="/login" className="mt-5 inline-block w-full rounded-2xl border border-slate-200 px-4 py-3 text-center text-sm font-semibold text-indigo-700">
          Go to Login
        </Link>
      </div>
    </div>
  );
}
